import RightBarMethod from "../../../components/common/RightBar/RightBarMethod";

export const VendorsRightBar = [
  RightBarMethod("Tasks", "t1", <i className="fa-solid fa-star"></i>, [
    RightBarMethod("Move In Tenant", "1", "", "", "/people/tenants/move-in-tenant"),
    RightBarMethod("New Owner", "2", "", "", "/people/owners/new"),
    RightBarMethod("New Vendor", "3", "", "", "/people/vendors/new"),
    RightBarMethod("Vendor ACH Setup", "4", "", "", "/people/vendors/new/vendor-ACH-setup"),
  ]),

  RightBarMethod(
    " REPORTS",
    "t2",
    <i className="fa-solid fa-chart-column"></i>,
    [
      RightBarMethod("Vendor Directory", "5", "", "", ""),
      RightBarMethod("Vendor Ledger", "6", "", "", ""),
    ]
  ),
];

export const tableData = [
  {
    key: "1",
    id: 1,
    name: "24/7 Realty Inc.",
    address: "2371 Fenton St. #220 Chula Vista CA 91914",
    trades: "",
    phone: "(518) 253-5338",
    email: "angelina@mysandiegobroker.com",
    vendorInformation: {
      salutation: "Dr",
      firstName: "Seerat",
      lastName: "Ali",
      companyName: "Seerat",
      tags: ["1059194"]
    },
    vendorCommunications: {
      portalActivated: "No"
    },
    contact: {
      phoneNumbers: [
        {
          number: "(309) 231-4041  Text",
          type: "phone",
          description: ""
        },
      ],
      emails: [
        {
          email: "mcarey91@gmail.com"
        }
      ],
      addresses: [
        {
          address: "10512 Cattail Terrace",
          addressTwo: "9723 NE 3rd Pl",
          city: "Midwest City",
          state: "OK",
          zipCode: "73130",
          country: "USA"
        }
      ],
      vendorAddressAsPayment: "Yes",
    },
    federalTax: {
      taxpayerName: "Aspire Premier Properties",
      taxpayerID: "XXX-XX-8012",
      taxpayerAccountNumber: "963375314969042201",
      send: "Yes",
      receiveElectronic: "Yes",
      sendingPreference: "Electronic"
    },
    accountingInformation: {
      checkConsolidation: "All bills on single check (hide extra stub detail)",
      holdPayments: "No",
      emaileCheckReceipt: "Yes",
      defaultCheckMemo: "--",
    },
    onlinePayables: {
      useOnlinePayables: "Yes",
      paymentType: "eCheck",
      ownerBankRoutingNumber: "XXXXX0030",
      ownerBankAccountNumber: "XXXXX4336",
      accountType: "Checking"
    },
    compliance: {
      workersCompExpiration: "--",
      generalLiabilityExpiration: "--",
      ePACertificationExpiration: "--",
      autoInsuranceExpiration: "--",
      stateLicenseExpiration: "--",
      contractExpiration: "--"
    }
  },
  {
    key: "2",
    id: 2,
    name: "405 Property Group",
    address: "2900 S. Telephone Rd. Suite 100 Moore OK 73160",
    trades: "--",
    phone: "--",
    email: "--",
    vendorInformation: {
      salutation: "Dr",
      firstName: "Seerat",
      lastName: "Ali",
      companyName: "Seerat",
      tags: ["1059194"]
    },
    vendorCommunications: {
      portalActivated: "No"
    },
    contact: {
      phoneNumbers: [
        {
          number: "(309) 231-4041  Text",
          type: "phone",
          description: "--"
        },
      ],
      emails: [
        {
          email: "mcarey91@gmail.com"
        }
      ],
      addresses: [
        {
          address: "10512 Cattail Terrace",
          addressTwo: "9723 NE 3rd Pl",
          city: "Midwest City",
          state: "OK",
          zipCode: "73130",
          country: "USA"
        }
      ],
      vendorAddressAsPayment: "Yes",
    },
    federalTax: {
      taxpayerName: "Aspire Premier Properties",
      taxpayerID: "XXX-XX-8012",
      taxpayerAccountNumber: "963375314969042201",
      send: "Yes",
      receiveElectronic: "Yes",
      sendingPreference: "Electronic"
    },
    accountingInformation: {
      checkConsolidation: "All bills on single check (hide extra stub detail)",
      holdPayments: "No",
      emaileCheckReceipt: "Yes",
      defaultCheckMemo: "--",
    },
    onlinePayables: {
      useOnlinePayables: "Yes",
      paymentType: "eCheck",
      ownerBankRoutingNumber: "XXXXX0030",
      ownerBankAccountNumber: "XXXXX4336",
      accountType: "Checking"
    },
    Compliance: {
      workersCompExpiration: "--",
      generalLiabilityExpiration: "--",
      ePACertificationExpiration: "--",
      autoInsuranceExpiration: "--",
      stateLicenseExpiration: "--",
      contractExpiration: "--"
    }
  },
  {
    key: "3",
    id: 3,
    name: "A New Creation L.L.C.",
    address: "11711 Lorene Ave  Midwest City OK 73130",
    trades:
      "General Contractor, Handyperson, Roofing, Doors/Windows, Repairs and Maintenance: Interior",
    phone: "(405) 202-2140",
    email: "gcombs71@gmail.com",
    vendorInformation: {
      salutation: "Dr",
      firstName: "Seerat",
      lastName: "Ali",
      companyName: "Seerat",
      tags: ["1059194"]
    },
    vendorCommunications: {
      portalActivated: "No"
    },
    contact: {
      phoneNumbers: [
        {
          number: "(309) 231-4041  Text",
          type: "phone",
          description: "--"
        },
      ],
      emails: [
        {
          email: "mcarey91@gmail.com"
        }
      ],
      addresses: [
        {
          address: "10512 Cattail Terrace",
          addressTwo: "9723 NE 3rd Pl",
          city: "Midwest City",
          state: "OK",
          zipCode: "73130",
          country: "USA"
        }
      ],
      vendorAddressAsPayment: "Yes",
    },
    federalTax: {
      taxpayerName: "Aspire Premier Properties",
      taxpayerID: "XXX-XX-8012",
      taxpayerAccountNumber: "963375314969042201",
      send: "Yes",
      receiveElectronic: "Yes",
      sendingPreference: "Electronic"
    },
    accountingInformation: {
      checkConsolidation: "All bills on single check (hide extra stub detail)",
      holdPayments: "No",
      emaileCheckReceipt: "Yes",
      defaultCheckMemo: "--",
    },
    onlinePayables: {
      useOnlinePayables: "Yes",
      paymentType: "eCheck",
      ownerBankRoutingNumber: "XXXXX0030",
      ownerBankAccountNumber: "XXXXX4336",
      accountType: "Checking"
    },
    Compliance: {
      workersCompExpiration: "--",
      generalLiabilityExpiration: "--",
      ePACertificationExpiration: "--",
      autoInsuranceExpiration: "--",
      stateLicenseExpiration: "--",
      contractExpiration: "--"
    }
  },
];

export const tradeList = [
  {
    value: "Alarm/Security",
    label: "Alarm/Security",
  },
  {
    value: "Appliances",
    label: "Appliances",
  },
  {
    value: "Capital Improvements",
    label: "Capital Improvements",
  },
  {
    value: "Carpet Cleaning",
    label: "Carpet Cleaning",
  },
  {
    value: "Carpet/Flooring",
    label: "Carpet/Flooring",
  },
  {
    value: "Cleaning",
    label: "Cleaning",
  },
  {
    value: "Deck Repair",
    label: "Deck Repair",
  },
  {
    value: "Doors/Windows",
    label: "Doors/Windows",
  },
  {
    value: "Drywall Repair",
    label: "Drywall Repair",
  },
  {
    value: "Electrical",
    label: "Electrical",
  },
  {
    value: "Elevator Services",
    label: "Elevator Services",
  },
  {
    value: "Fences/Gates",
    label: "Fences/Gates",
  },
  {
    value: "Fire/Water Damage",
    label: "Fire/Water Damage",
  },
  {
    value: "Fireplace/Chimney",
    label: "Fireplace/Chimney",
  },
  {
    value: "Garage Doors",
    label: "Garage Doors",
  },
  {
    value: "General Contractor",
    label: "General Contractor",
  },
  {
    value: "Gutter Cleaning",
    label: "Gutter Cleaning",
  },
  {
    value: "Handyperson",
    label: "Handyperson",
  },
  {
    value: "HVAC",
    label: "HVAC",
  },
  {
    value: "Inspections",
    label: "Inspections",
  },
  {
    value: "Keys/Locks",
    label: "Keys/Locks",
  },
  {
    value: "Landscaping",
    label: "Landscaping",
  },
  {
    value: "Other",
    label: "Other",
  },
  {
    value: "Painting",
    label: "Painting",
  },
  {
    value: "Parking Lots/Driveways",
    label: "Parking Lots/Driveways",
  },
  {
    value: "Pest Control",
    label: "Pest Control",
  },
  {
    value: "Plumbing",
    label: "Plumbing",
  },
  {
    value: "Pool/Spa",
    label: "Pool/Spa",
  },
  {
    value: "Preventative Maintenance",
    label: "Preventative Maintenance",
  },
  {
    value: "Redevelopment",
    label: "Redevelopment",
  },
  {
    value: "Repairs and Maintenance: Exterior",
    label: "Repairs and Maintenance: Exterior",
  },
  {
    value: "Repairs and Maintenance: Interior",
    label: "Repairs and Maintenance: Interior",
  },
  {
    value: "Roofing",
    label: "Roofing",
  },
  {
    value: "Septic System",
    label: "Septic System",
  },
  {
    value: "Smoke/Carbon Monoxide Detectors",
    label: "Smoke/Carbon Monoxide Detectors",
  },
  {
    value: "Snow Removal",
    label: "Snow Removal",
  },
  {
    value: "Trash/Recycling",
    label: "Trash/Recycling",
  },
  {
    value: "Turnover",
    label: "Turnover",
  },
  {
    value: "Utilities",
    label: "Utilities",
  },

]

export const vendorType = [
  {
    value: "General",
  },
  {
    value: "Utility",
  },
  {
    value: "Management Company",
  },
];

export const vendorTrade = [
  "Test 1",
  "Test 2",
  "Test 3",
  "Test 4",
  "Test 5",
  "Test 6",
];